"use client";

import { Livestream } from "@punchup/data/legacy/livestreaming";
import dayjs from "@punchup/utils/dayjs";

export default function LivestreamCheckoutScheduledTime({
  livestream,
}: {
  livestream: Livestream;
}) {
  return (
    <p className="text-sm text-gray-500">
      Scheduled to start{" "}
      {dayjs(livestream.start_time).format("dddd MMM D, h:mmA z")}
    </p>
  );
}
